import { module } from '@/store/modules/bank/helper';
import signup from '@/api/signup';

export default {
  namespaced: true,

  actions: {
    popular({ rootGetters }, size) {
      return signup.getPopularBanks(size, rootGetters['settings/allowedProviders']);
    },
    search({ rootGetters }, data) {
      return signup.searchBank({
        ...data,
        allowedProviders: rootGetters['settings/allowedProviders'],
      });
    },
  },
} as module;
